import {EToastMessageOptions, EToastMessageSeverity} from '@app/shared/enums/toast-message.enum';
import {MessageService} from 'primeng/api';

export class ToastMessageUtils {
  static readonly GLOBAL_TOAST = 'global-toast';
  static showMessage(toastInfo: {
    messageService: MessageService;
    toastKey: string;
    severity: string;
    messageDetail: string;
    closable?: boolean;
    life?: number;
    summary?: string;
  }): void {
    toastInfo.messageService.add({
      key: toastInfo.toastKey || ToastMessageUtils.GLOBAL_TOAST,
      severity: toastInfo.severity || EToastMessageSeverity.Error,
      detail: toastInfo.messageDetail,
      closable: toastInfo.closable || true,
      life: toastInfo.life || EToastMessageOptions.LifeTime,
      summary: toastInfo.summary,
    });
  }
}
